import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { FacilityManager } from '../managers/facility.manager';

@Injectable({
  providedIn: 'root',
})
export class StoreGuard {
  constructor(private _facilityManager: FacilityManager) {}

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this._facilityManager.isFacilitySelected();
  }
}
